import React from 'react';
import SellerFinance from '../seller/SellerFinance';
import { useAuth } from '../../contexts/AuthContext';

const SuperAccountantCreateCase = () => {
  const { user } = useAuth();

  // Kiểm tra quyền super_accountant
  if (!user?.is_super_accountant) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Không có quyền truy cập</h1>
          <p className="text-gray-600">Chỉ Super Accountant mới có quyền tạo Financial Case</p>
        </div>
      </div>
    );
  }

  return <SellerFinance isSuperAccountant={true} />;
};

export default SuperAccountantCreateCase;
